export default "__VITE_ASSET__DqJnyq$k__"